import { useCallback, useRef } from 'react';
import { Sheet, SheetRef } from 'react-modal-sheet';
import { useDispatch, useSelector } from 'react-redux';
// import {
//   setDrawerOpen,
//   setQuickFilter
// } from '../../../../../redux/slices/sahelSlice';
import { QuickFilter } from '../../../types';
import PriceRangeFilter from '../PriceRangeFilter';
import { SearchFiltersTypes } from '../../../../../reducers/search-filters/reducer';
import SelectionFilter from '../SelectionFilter';
import FilterActions from '../FilterActions';
import { useRouter } from 'next/router';
import FiltersDrawerHeader from './FiltersDrawerHeader';
import OnboardingContainer from '../OnboardingContainer';
import DeliveryFilter from '../DeliveryFilter';
import { setDrawerOpen, setQuickFilter } from '../../../../../redux/slices/mapSlice';

const spring = {
  type: 'spring',
  damping: 10,
  stiffness: 100
};

const MQuickFiltersDrawer = () => {
  const { locale } = useRouter();

  const sheetRef = useRef<SheetRef>();

  const dispatch = useDispatch();

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const quickFilter = useSelector((state: any) => state.map.quickFilter);
  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const snapPoints = [quickFilter === QuickFilter.NAWY_NOW ? 0.49 : 0.9, 0];

  const handleCloseDrawer = () => {
    dispatch(setQuickFilter(null));

    if (isMobile && selectedCompound) {
      dispatch(setDrawerOpen(true));
    }
  };

  const renderDrawer = useCallback(() => {
    if (quickFilter === QuickFilter.PRICE) {
      return <PriceRangeFilter />;
    }

    if (quickFilter === QuickFilter.PROPERTY_TYPE) {
      return <SelectionFilter filterType={SearchFiltersTypes.PROPERTY_TYPES} />;
    }

    if (quickFilter === QuickFilter.DELIVERY) {
      return <DeliveryFilter/>;
    }

    if (quickFilter === QuickFilter.NAWY_NOW) {
      return <OnboardingContainer />;
    }
  }, [quickFilter]);

  return (
    <Sheet
      ref={sheetRef}
      isOpen={quickFilter && isMobile}
      onClose={handleCloseDrawer}
      snapPoints={snapPoints}
      initialSnap={0}
      animate
      transition={spring}
      prefersReducedMotion
      style={{ zIndex: 999999 }}
      
    >
      <Sheet.Container
        style={{
          padding: '8px 16px 16px 16px'
        }}
      >
        <Sheet.Header
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: '16px'
          }}
        >
          <Sheet.Header />
          {isMobile && quickFilter !== 'nawy_now' && (
            <FiltersDrawerHeader filterType={quickFilter} />
          )}
        </Sheet.Header>

        <Sheet.Content
          style={{
            width: '100%',
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            direction: locale === 'ar' ? 'rtl' : 'ltr'
          }}
          disableDrag
        >
          <Sheet.Scroller className="hide-scrollbar">
            {renderDrawer()}
          </Sheet.Scroller>
          {quickFilter !== 'nawy_now' && <FilterActions />}
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};

export default MQuickFiltersDrawer;
